import { render } from "./IndexConfigGeneral.vue?vue&type=template&id=ceb0a7ee"
import script from "./IndexConfigGeneral.vue?vue&type=script&lang=js"
export * from "./IndexConfigGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__